// decision-dashboard.component.ts
import { Component, OnInit } from '@angular/core';

import { DashboardserviceService } from '../services/dashboardservice.service';


import { GestockService } from '../services/gestock.service';

import { TableListComponent } from '../table-list/table-list.component';

import { DetailStockStatComponent } from '../detail-stock-stat/detail-stock-stat.component';

import { MatDialog } from '@angular/material/dialog';



interface SalesData {
  produit: string;
  quantiteVendue: number;
  chiffreAffaire: number;
  rotation: number; // nombre de rotations sur la période
  dormant: boolean; // si le produit est resté invendu
}

@Component({
  selector: 'app-decision-dashboard',
  templateUrl: './decision-dashboard.component.html',
  styleUrls: ['./decision-dashboard.component.css']
})
export class DecisionDashboardComponent implements OnInit {


  boutiques: any; //string[] = ['Toutes', 'Boutique A', 'Boutique B'];
  selectedBoutique: string = 'Toutes';

  dateRange = {
    start: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    end: new Date()
  };

  stockRotation : any;
  dormantProducts = 0;
  stockValue = 0;
  availabilityRate = 0;
  articles_en_voie_de_rupture = 0;
  clientsDormants = 0 ;


  // Données simulées
  allData: SalesData[] = [
    { produit: 'Riz 50kg', quantiteVendue: 120, chiffreAffaire: 720000, rotation: 3.2, dormant: false },
    { produit: 'Huile 5L', quantiteVendue: 85, chiffreAffaire: 425000, rotation: 2.5, dormant: false },
    { produit: 'Savon', quantiteVendue: 0, chiffreAffaire: 0, rotation: 0, dormant: true },
    { produit: 'Sucre 1kg', quantiteVendue: 60, chiffreAffaire: 210000, rotation: 1.8, dormant: false },
    { produit: 'Lait concentré', quantiteVendue: 0, chiffreAffaire: 0, rotation: 0, dormant: true },
    { produit: 'Farine 25kg', quantiteVendue: 30, chiffreAffaire: 270000, rotation: 2.0, dormant: false },

    { produit: 'Moto 125cc', quantiteVendue: 0, chiffreAffaire: 0, rotation: 0, dormant: true },
    { produit: 'Tricycle Cargo', quantiteVendue: 0, chiffreAffaire: 0, rotation: 0, dormant: true },
    { produit: 'Kit Chaîne', quantiteVendue: 0, chiffreAffaire: 0, rotation: 0, dormant: true },
    { produit: 'Casque Jet', quantiteVendue: 0, chiffreAffaire: 0, rotation: 0, dormant: true },
  ];

  filteredData: SalesData[] = [];

  topSellingProducts :any;

  lowSellingProducts: any;

  mostProfitable : any ;

  boutiquePerformance = [
    { name: 'Boutique A', sales: 2000000, expenses: 500000 },
    { name: 'Boutique B', sales: 1600000, expenses: 700000 }
  ];

  //selectedPeriod = '30'; // default: last 30 days

  productsMostSold = [
    { name: 'Produit A', quantity: 320 },
    { name: 'Produit B', quantity: 280 },
    { name: 'Produit C', quantity: 245 }
  ];

  productsLeastSold = [
    { name: 'Produit X', quantity: 5 },
    { name: 'Produit Y', quantity: 12 },
    { name: 'Produit Z', quantity: 15 }
  ];

  productsMostProfitable = [
    { name: 'Produit A', profit: 800000 },
    { name: 'Produit D', profit: 620000 },
    { name: 'Produit E', profit: 500000 }
  ];

  storePerformance = [
    { name: 'Boutique 1', ventes: 1500000, depenses: 700000 },
    { name: 'Boutique 2', ventes: 1200000, depenses: 600000 },
    { name: 'Boutique 3', ventes: 800000, depenses: 500000 }
  ];

  filteredDataAggreg : any ;

  recouvrementBoutiques : any ;

  samacaabiyoonwii : any ;

  retourClientWS:any ;

  onPeriodChange(period: string) {
    console.log('Filtrage par période :', period);
  }

  getNetProfit(b: any): number {
    return b.sales - b.expenses;
  }

  getTauxDeRentabilite(){
    if(this.filteredDataAggreg.chiffre_affaire!=0 )
      return Math.trunc(Number((this.filteredDataAggreg.marge_totale/this.filteredDataAggreg.chiffre_affaire)*100));
    else      
        return 0;
  }


  /*getTauxDeRentabilite(){
    if(this.filteredDataAggreg.totalExpenses!=0 )
      return Number((this.filteredDataAggreg.profit_net/this.filteredDataAggreg.chiffre_affaire)*100);
    else
      if(this.filteredDataAggreg.profit_net)
        return 1000;
      else
        return 0;
  }*/


getTauxRentabiliteClass(): string {
  const taux = this.getTauxDeRentabilite();
  if (taux == null || taux <= 0) return 'rentabilite-nulle';
  if (taux < 100) return 'rentabilite-faible';
  return 'rentabilite-bonne';
}

  constructor(public dialog: MatDialog, private dashboardService: DashboardserviceService, private configServer: GestockService) {}

   ngOnInit(): void {
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
    this.getAllPoints(); 

    /*this.loadDashboardData() ;
    this.loadDashboardData2() ;*/
  }


  openDialogDetailOp(optionChoisie): void {  
    let passedValues = {'element': {dateRange: this.dateRange, 
            optionChoisie: optionChoisie, 
            selectedBoutique: this.selectedBoutique,
            boutiques: this.boutiques} } ;

    const dialogRef = this.dialog.open(TableListComponent, {
      data: passedValues, width:'100%',
        height: '100vh',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });    
  }

  openDialogDetailStock(optionChoisie): void {  
    let passedValues = {'element': {dateRange: this.dateRange, 
            optionChoisie: optionChoisie, 
            selectedBoutique: this.selectedBoutique,
            boutiques: this.boutiques} } ;

    const dialogRef = this.dialog.open(DetailStockStatComponent, {
      data: passedValues, width:'100%',
        height: '100vh',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });    
  }


  getAllPoints(){

    this.configServer.getAllPoints(this.samacaabiyoonwii).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;

      if(statutreq==1){
        console.log("Done") ;
        this.boutiques = this.retourClientWS.data ; 
        if(this.boutiques.length==1)
          this.selectedBoutique = this.boutiques[0].idPoint ;
        
        this.loadDashboardData();
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }


loadDashboardData() {
   console.log("there190") ;

   if(this.dateRange.start==undefined || this.dateRange.end==undefined)
     return;

   let date_debut = this.dateRange.start.toISOString().split('T')[0] ;
   let date_fin = this.dateRange.end.toISOString().split('T')[0] ;

  this.dashboardService.getStockStats(this.samacaabiyoonwii, this.selectedBoutique, date_debut, date_fin ).then( (res) => {
      console.log(res);
      this.getFinanceStats();
      if (res.statutreq === 1) {
        this.stockRotation = +(+res.data.rotation_moyenne).toFixed(2);
        this.dormantProducts = +res.data.produits_dormants;
        this.stockValue = +res.data.valeur_stock_totale;
        this.availabilityRate = +(+res.data.taux_disponibilite_moyen).toFixed(1);
        this.articles_en_voie_de_rupture = +(+res.data.articles_en_voie_de_rupture).toFixed(1);
      } else {
        console.warn('Erreur serveur:', res.message);
      }
  }) ;        

}

  getFinanceStats(){
   let date_debut = this.dateRange.start.toISOString().split('T')[0] ;
   let date_fin = this.dateRange.end.toISOString().split('T')[0] ;
    this.dashboardService.getFinanceStats(this.samacaabiyoonwii, this.selectedBoutique, date_debut, date_fin ).then( (res) => {
        console.log(res);
        this. getTopBottomProfitProducts();
        if (res.statutreq === 1) {
          this.filteredDataAggreg = res.data ;
        } else {
          console.warn('Erreur serveur:', res.message);
        }
    }) ;        

  }


  getTopBottomProfitProducts(){
   let date_debut = this.dateRange.start.toISOString().split('T')[0] ;
   let date_fin = this.dateRange.end.toISOString().split('T')[0] ;
    this.dashboardService.getTopBottomProfitProducts(this.samacaabiyoonwii, this.selectedBoutique, date_debut, date_fin ).then( (res) => {
        console.log(res);
        this.loadRecouvrementBoutique();
        if (res.statutreq === 1) {
          this.topSellingProducts = res.data.plus_vendus ;
          this.lowSellingProducts = res.data.moins_vendus ;
          this.mostProfitable = res.data.plus_rentables ;
        } else {
          console.warn('Erreur serveur:', res.message);
        }
    }) ;        
  }

  interpretRotationRate(rate): string {
    rate = Number(rate) ;
    if (rate === null || rate === undefined || rate < 0) {
      return "Taux de rotation invalide.";
    }

    if (rate === 0) {
      return `Un taux de 0 signifie qu'aucune vente n'a été réalisée sur la période. 
  Le stock est totalement dormant.`;
    }

    const percentSold = (rate * 100).toFixed(2);
    const periodsToClear = rate > 0 ? Math.round(1 / rate) : Infinity;

    return `Un taux de ${rate} signifie que :
    
  - seulement ${percentSold} % du stock moyen a été vendu sur la période
  - il faudrait environ ${periodsToClear} périodes identiques pour écouler le stock`;

  }


  interpretProfitabilityRate(rate): string {
    rate = Number(rate) ;
    if (rate === null || rate === undefined || rate < 0) {
      return "Taux de rentabilité invalide.";
    }

    let interpretation = '';

    if (rate < 5) {
      interpretation = "Rentabilité faible (<5%) : la boutique peine à générer du profit net. Attention aux coûts élevés.";
    } else if (rate >= 5 && rate < 10) {
      interpretation = "Rentabilité moyenne (5-10%) : la boutique est rentable mais la marge de sécurité est limitée.";
    } else if (rate >= 10 && rate < 20) {
      interpretation = `Rentabilité correcte (${rate}%) : chaque 100 FCFA de vente génère ${rate.toFixed(0)} FCFA de profit net. La boutique est rentable.`;
    } else if (rate >= 20) {
      interpretation = `Très bonne rentabilité (${rate}%) : la boutique génère une marge confortable sur ses ventes.`;
    }

    return interpretation;
  }




  loadRecouvrementBoutique(){
   let date_debut = this.dateRange.start.toISOString().split('T')[0] ;
   let date_fin = this.dateRange.end.toISOString().split('T')[0] ;
    this.dashboardService.loadRecouvrementBoutique(this.samacaabiyoonwii, this.selectedBoutique, date_debut, date_fin ).then( (res) => {
        console.log(res);
        this.loadClientsDormant() ;
        if (res.statutreq === 1) {
          this.recouvrementBoutiques = res.data ;
        } else {
          console.warn('Erreur serveur:', res.message);
        }
    }) ;        
  }

  loadClientsDormant(){

    console.log("Client Dormant Yi");

   let date_debut = this.dateRange.start.toISOString().split('T')[0] ;
   let date_fin = this.dateRange.end.toISOString().split('T')[0] ;
    this.dashboardService.loadClientsDormant(this.samacaabiyoonwii, this.selectedBoutique, date_debut, date_fin ).then( (res) => {
        console.log("Client Dormant: ", res);
        if (res.statutreq === 1) {
          this.clientsDormants = res.data.length ;
        } else {
          console.warn('Erreur serveur:', res.message);
        }
    }) ;        
  }


  loadDashboardDataOld(): void {
    // Dans une vraie app, on filtrerait par boutique et par date ici
    this.filteredData = [...this.allData];

    // Calcul d'indicateurs basés sur filteredData
    const totalCA = this.filteredData.reduce((acc, d) => acc + d.chiffreAffaire, 0);
    const totalProduits = this.filteredData.length;
    const produitsDormants = this.filteredData.filter(p => p.dormant).length;
    const rotations = this.filteredData.map(p => p.rotation);
    const rotationMoyenne = rotations.reduce((a, b) => a + b, 0) / rotations.length;


    const coutDeReviens = 2.2*totalCA/3; 

    this.filteredDataAggreg.totalSales = Math.trunc(totalCA) ;
    this.filteredDataAggreg.totalExpenses = Math.trunc(totalCA - totalCA/3) ;
    this.filteredDataAggreg.benefit = Math.trunc(this.filteredDataAggreg.totalSales - this.filteredDataAggreg.totalExpenses) ;
    this.filteredDataAggreg.rentabilityRate =  (totalCA - coutDeReviens)/(coutDeReviens) ;



    this.stockRotation = +rotationMoyenne.toFixed(2);
    this.dormantProducts = produitsDormants;
    this.stockValue = totalCA;
    this.availabilityRate = +(((totalProduits - produitsDormants) / totalProduits) * 100).toFixed(1);

    if (this.selectedBoutique === 'Boutique A') {
      this.stockRotation = 4.1;
      this.dormantProducts = 8;
      this.stockValue = 760000;
      this.availabilityRate = 95.2;
    } else if (this.selectedBoutique === 'Boutique B') {
      this.stockRotation = 2.7;
      this.dormantProducts = 15;
      this.stockValue = 520000;
      this.availabilityRate = 88.6;
    } else {
      // Tous
      this.stockRotation = 3.4;
      this.dormantProducts = 12;
      this.stockValue = 1234500;
      this.availabilityRate = 92.5;
    }
  }


  onBoutiqueChange(): void {
    console.log("Called Boutique Change") ;
    this.loadDashboardData();
  }

  onPeriodeChange(): void {
    console.log("Called Boutique Change") ;
    this.loadDashboardData();
  }

  onDateChange(): void {
    this.loadDashboardData();
  }

  formatMoney(val: number): string {
    return val.toLocaleString('fr-FR') + ' FCFA';
  }


  chartDataTop: any;
  chartDataProfit: any;
  chartOptions: any = {
    axisY: {
      onlyInteger: true
    },
    height: '200px'
  };


  loadDashboardData2(): void {
    const mockData = [
      { name: 'Moto 125cc', qty: 120, profit: 800000 },
      { name: 'Tricycle Cargo', qty: 85, profit: 680000 },
      { name: 'Kit Chaîne', qty: 60, profit: 300000 },
      { name: 'Casque Jet', qty: 40, profit: 200000 },
      { name: 'Riz 50kg', qty: 90, profit: 400000 }
    ];

/*    this.stockRotation = 3.8;
    this.dormantProducts = 7;
    this.stockValue = 2450000;
    this.availabilityRate = 91.2;
*/
    this.chartDataTop = {
      labels: mockData.map(d => d.name),
      series: [mockData.map(d => d.qty)]
    };

    this.chartDataProfit = {
      labels: mockData.map(d => d.name),
      series: [mockData.map(d => d.profit)]
    };
  }

}

